export const VuetifyMaterialColors = [
  { name: "red", value: "#F44336" },
  { name: "teal", value: "#009688" },
  { name: "purple", value: "#9C27B0" },
  { name: "blue", value: "#2196F3" },
  { name: "amber", value: "#FFC107" },
  { name: "lightgreen", value: "#8BC34A" },
  { name: "green", value: "#4CAF50" },
];

export const Colors = [
  { name: "consumption", value: "red" },
  { name: "inverter", value: "teal" },
  { name: "fromGrid", value: "purple" },
  { name: "toGrid", value: "blue" },
  { name: "fve", value: "amber" },
  { name: "charging", value: "lightgreen" },
  { name: "discharging", value: "green" },
];

export const basicColors = {
  load: "red darken-2",
  inverter: "blue grey darken-2",
  grid: "purple darken-2",
  battery: "light-green darken-2",
  pv: "yellow darken-2",
};

export const customColors = {
  dark: {
    load: ["#F44336", "#660000", "#333333"],
    fromGrid: ["#9C27B0", "#330033", "#333333"],
    toGrid: ["#039BE5", "#000000", "#333333"],
    fromBattery: ["#C6FF00", "#25AA11", "#333333"],
    toBattery: ["#00E676", "#005053", "#333333"],
    pv: ["#FFEB3B", "#F57F17", "#333333"],
    maximum: ["#333333", "#333333", "#333333"],
  },
  light: {
    load: ["#F44336", "#660000", "#333333"],
    fromGrid: ["#9C27B0", "#330033", "#333333"],
    toGrid: ["#039BE5", "#000000", "#333333"],
    fromBattery: ["#C6FF00", "#25AA11", "#333333"],
    toBattery: ["#00E676", "#005053", "#333333"],
    pv: ["#FFEB3B", "#FF6F00", "#333333"],
    maximum: ["#ECEFF1", "#ECEFF1", "#ECEFF1"],
  },
};

export const chartColors = {
  line: {
    y1: {
      backgroundColor: "rgba(211, 47, 47, 0.1)",
      borderColor: "#D32F2F",
    },
    y2: {
      backgroundColor: "rgba(123, 31, 162, 0.1)",
      borderColor: "#7B1FA2",
    },
    y3: {
      backgroundColor: "rgba(251, 192, 45, 0.1)",
      borderColor: "#FBC02D",
    },
    y4: {
      backgroundColor: "rgba(104, 159, 56, 0.1)",
      borderColor: "#689F38",
    },
    y5: {
      backgroundColor: "rgba(198, 255, 0, 0.1)",
      borderColor: "#C6FF00",
    },
    spotAvg: {
      backgroundColor: "rgba(104, 159, 56, 0.0)",
      borderColor: "#689F38",
    },
    spotMax: {
      backgroundColor: "rgba(211, 47, 47, 0.0)",
      borderColor: "#D32F2F",
    },
    spot: {
      backgroundColor: "rgba(251, 192, 45, 0.1)",
      borderColor: "#FBC02D",
    },
    spotMin: {
      backgroundColor: "rgba(3, 169, 244, 0.0)",
      borderColor: "#03A9F4",
    },
  },
  bar: {
    y1: {
      backgroundColor: "rgba(211, 47, 47, 0.1)",
      borderColor: "#D32F2F",
    },
    y2: {
      backgroundColor: "rgba(123, 31, 162, 0.1)",
      borderColor: "#7B1FA2",
    },
    y3: {
      backgroundColor: "rgba(3, 169, 244, 0.1)",
      borderColor: "#03A9F4",
    },
    y4: {
      backgroundColor: "rgba(251, 192, 45, 0.1)",
      borderColor: "#FBC02D",
    },
    y5: {
      backgroundColor: "rgba(0, 200, 83, 0.1)",
      borderColor: "#00C853",
    },
    y6: {
      backgroundColor: "rgba(104, 159, 56, 0.1)",
      borderColor: "#689F38",
    },
    y7: {
      backgroundColor: "rgba(198, 255, 0, 0.1)",
      borderColor: "#C6FF00",
    },
    spotAvg: {
      backgroundColor: "rgba(104, 159, 56, 0.0)",
      borderColor: "#689F38",
    },
    spotMax: {
      backgroundColor: "rgba(211, 47, 47, 0.0)",
      borderColor: "#D32F2F",
    },
    spot: {
      backgroundColor: "rgba(251, 192, 45, 0.1)",
      borderColor: "#FBC02D",
    },
    spotMin: {
      backgroundColor: "rgba(3, 169, 244, 0.0)",
      borderColor: "#03A9F4",
    },
  },
};

export const evcGaugeColors = {
  dark: {
    energy: ["#8bc34a", "#aeea00"],
    power: ["#00BCD4", "#8BC34A"],
    maximum: ["#333333", "#333333"],
  },
  light: {
    energy: ["#C6FF00", "#25AA11"],
    power: ["#FFEB3B", "#FF6F00"],
    maximum: ["#ECEFF1", "#ECEFF1"],
  },
};

export function getPieChartsColor(name) {
  let color = "";

  for (let i = 0; i < Colors.length; i++) {
    if (name == Colors[i].name) {
      for (let j = 0; j < VuetifyMaterialColors.length; j++) {
        if (Colors[i].value == VuetifyMaterialColors[j].name) {
          color = VuetifyMaterialColors[j].value;
        }
      }
    }
  }

  return color;
}

export const svgGaugeColors = {
  charger: ["#8BC34A", "#AEEA00", "#FFEB3B", "#FFFF00", "#FF6D00"],
  negative: ["#f4c009", "#de3a21"],
  positive: ["#C6FF00", "#8BC34A"],
  load: ["#F44336", "#D50000"],
  inverter: ["#607D8B", "#009688"],
  grid: ["#9C27B0", "#512DA8"],
  battery: ["#C6FF00", "#8BC34A"],
  pv: ["#f4c009", "#de3a21"],

  gridImport: ["#2196F3", "#1976D2"],

  sun: ["#f4c009", "#de3a21"],
  wind: ["#00BCD4", "#01579B"],
};

export const themeColors = {
  palete1: ["#F44336", "#E65100", "#FF9800", "#FFC107", "#AEEA00"],
  palete2: ["#6200EA", "#64DD17", "#00C853", "#8BC34A", "#4CAF50"],
  palete3: ["#009688", "#00BCD4", "#2196F3", "#03A9F4", "#B71C1C"],
  palete4: ["#F50057", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5"],
};

export const inspectChartsColors = ["#F44336", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5", "#2196F3", "#00BCD4", "#009688", "#4CAF50", "#8BC34A", "#CDDC39", "#FFEB3B", "#FFC107", "#FF9800", "#795548", "#607D8B", "#9E9E9E"];

/**
 * getColorTemperature - Based on given value this function return temperature defined color. Can be used for styles too.
 * @param {value} value - Number input value from which is color derived
 * @param {style} style - Boolean if it used for style
 * @return {color} output color used for styling
 **/
export function getColorTemperature(value, style) {
  let color = "";

  if (style === true) {
    color = "color: ";
  }

  if (value > 55) {
    color += "#F44336";
  } else if (value > 40) {
    color += "#FF9800";
  } else if (value > 5) {
    color += "#8BC34A";
  } else if (value > -10) {
    color += "#00BCD4";
  } else {
    color += "#673AB7";
  }

  return color;
}

/**
 * getColorVoltage - Based on given value this function return voltage defined color. Can be used for styles too.
 * @param {value} value - Number input value from which is color derived
 * @param {style} style - Boolean if it used for style
 * @return {color} output color used for styling
 **/
export function getColorVoltage(value, style) {
  let color = "";

  if (style === true) {
    color = "color: ";
  }

  if (value > 3.85) {
    color += "#DD2C00";
  } else if (value > 3.65) {
    color += "#FF5722";
  } else if (value > 2.85) {
    color += "#8BC34A";
  } else if (value > 2.65) {
    color += "#03A9F4";
  } else {
    color += "#00BCD4";
  }

  return color;
}

/* export { getColorTemperature, getColorVoltage }; */
